(function() {
  define('tlhConstants',['angular'], function() {
    'use strict';
    return angular.module('tlhConstants', []).constant('TlhCmsEvents', {
      PAGE_MODIFIED: 'tlh-cms-page-modified',
      PAGE_UNMODIFIED: 'tlh-cms-page-unmodified',
      SAVE_ALL: 'tlh-cms-save-all',
      CANCEL_ALL: 'tlh-cms-cancel-all',
      SAVE_SUCCESS: 'tlh-cms-save-success',
      SAVE_FAILED: 'tlh-cms-save-failed',
      DISABLE_ACTIONS: 'tlh-cms-disable-actions',
      ENABLE_ACTIONS: 'tlh-cms-enable-actions'
    });
  });

}).call(this);

//# sourceMappingURL=constants.js.map
;
